<template>
  <div>
    <table-temp title="联系人信息" :flag="1" :tableData="contactData" :columnData="tableConf[0]" @editTable="editTable"
      @handleSelectionChange="handleSelectionChange">
      <div slot="tool">
        <el-button type="primary" class="borderBtn" @click="contactFinAdd('contact')">添加<i
            class="button-icon icon-tianjia"></i></el-button>
        <el-button type="danger" plain class="borderBtn" @click="del('1')">删除<i class="button-icon icon-shanchu"></i>
        </el-button>
      </div>
    </table-temp>
    <table-temp v-if="!this.isAgency" title="高级管理人员信息" :flag="2" :tableData="legalData" :columnData="tableConf[1]"
      @editTable="editTable" @handleSelectionChange="handleSelectionChange">
      <div slot="tool">
        <el-button type="primary" class="borderBtn" @click="legalCompAdd('legal')">添加<i
            class="button-icon icon-tianjia"></i></el-button>
        <el-button type="danger" plain class="borderBtn" @click="del('2')">删除<i class="button-icon icon-shanchu"></i>
        </el-button>
      </div>
    </table-temp>

    <table-temp v-if="this.isAgency" title="法定代表人/执行事务合伙人（委派代表）信息" :flag="2" :tableData="legalData"
      :columnData="legalDataConf" @editTable="editTable" @handleSelectionChange="handleSelectionChange">
      <div slot="tool">
        <el-button type="primary" class="borderBtn" @click="legalCompAdd('legal')">添加<i
            class="button-icon icon-tianjia"></i></el-button>
        <el-button type="danger" plain class="borderBtn" @click="del('2')">删除<i class="button-icon icon-shanchu"></i>
        </el-button>
      </div>
    </table-temp>

    <table-temp v-if="!this.isAgency" title="实际控制人信息" :flag="3" :tableData="controllerData" :columnData="tableConf[2]"
      @editTable="editTable" @handleSelectionChange="handleSelectionChange">
      <div slot="tool">
        <el-button type="primary" class="borderBtn" @click="controllerAdd('controller')">添加<i
            class="button-icon icon-tianjia"></i></el-button>
        <el-button type="danger" plain class="borderBtn" @click="del('3')">删除<i class="button-icon icon-shanchu"></i>
        </el-button>
      </div>
    </table-temp>

    <div class="footerBtn">
      <el-button @click="pre">上一步</el-button>
      <el-button class="mainBtn" @click="DoDebounce(save, 'timer5')">保存</el-button>
      <el-button class="mainBtn" @click="DoDebounce(next, 'timer6')">保存并下一步</el-button>
    </div>

    <!--联系人-->
    <contact-dialog :dialogVisible="contactVisible" :title="title" :tableData="commonData" @closeDialog="closeDialog()"
      @reload="reload" :codeId="codeId" :detailId="detailId" :type="contactFinType" :destroy-on-close="true">
    </contact-dialog>

    <!--高级管理人-->
    <legal-dialog :dialogVisible="legalVisible" :title="title" :tableData="commonData" @closeDialog="closeDialog()"
      @reload="reload" :codeId="codeId" :detailId="detailId" :type="legalRiskType" :destroy-on-close="true">
    </legal-dialog>
    <!--实际控制人-->
    <controller-dialog :dialogVisible="controllerVisible" :title="title" :tableData="commonData"
      @closeDialog="closeDialog()" @reload="reload" :codeId="codeId" :detailId="detailId" :type="controllerFinType"
      :destroy-on-close="true"></controller-dialog>
  </div>
</template>

<script>
import { step3 } from "@/conf/newAgency";
import { legalDataItem } from "@/conf/AgencyConf";
import TableTemp from "../table";
import ContactDialog from "../dialog/contact";
import LegalDialog from "../dialog/legal";
import ControllerDialog from "../dialog/controller";
import comMixin from "common/js/mixin/comMixin";
import { getPersons, delStep3, getLegalDetail } from "common/js/api";
import { debounce } from 'common/js/tools.js'
export default {
  components: {
    TableTemp,
    ContactDialog,
    LegalDialog,
    ControllerDialog,
  },

  mixins: [comMixin],

  data() {
    return {
      tableConf: step3,
      legalDataConf: legalDataItem,
      // 联系人
      contactData: [],
      //高级管理人
      legalData: [],
      //实际控制人
      controllerData: [],
      // 弹窗区分flag
      flag: "",
      //通用数据
      commonData: {},
      //通用title
      title: "",
      Key: 0,
      //联系人dialog
      contactVisible: false,
      // 高级管理人dialog
      legalVisible: false,
      legalVisibleKey: 0,
      // 实际控制人dialog
      controllerVisible: false,
      controllerVisibleKey: 0,
      codeId: this.$route.query.codeId,
      step: 2,
      contactFinType: 0,
      legalRiskType: 0,
      controllerFinType: 0,
      detailId: 0,
      selectIds: [],
      isAgency: false,
      contactVisibleKey: 0,
    };
  },

  mounted() {
    this.getAllPerson();

    this.isAgency =
      this.$route.path == "/FundManagement/NewAgency" ? false : true;
  },

  methods: {
    async getAllPerson() {
      const { result } = await getPersons(this.codeId);
      this.contactData = result.linkman;
      this.legalData = this.convernData(result.expertMgrman);
      // this.complianceData = this.convernSexData(result.riskman);
      this.controllerData = result.controlman;
    },
    DoDebounce(func, timer) {
      debounce(func, 2000, timer, true)
    },
    convernData(data) {
      data.forEach((item) => {
        if (item.personType == 2) {
          item.personType = "法定代表人/执行事务合伙人（委派代表）";
        } else if (item.personType == 3) {
          item.personType = "投资经理";
        } else if (item.personType == 4) {
          item.personType = "合规风控负责人";
        }
        if (item.qualification == 1) {
          item.qualification = "是";
        } else if (item.qualification == 0) {
          item.qualification = "否";
        }
        item.birthday = item.birthday
          ? this.$moment(item.birthday).format("YYYY-MM-DD")
          : "";
      });
      return data;
    },
    reConvernData(item) {
      item.personType =
        item.personType == "法定代表人/执行事务合伙人（委派代表）"
          ? 2
          : item.personType == "投资经理"
            ? 3
            : 4;
      item.birthday = item.birthday
        ? this.$moment(item.birthday).format("YYYY-MM-DD")
        : "";
      return item;
    },
    convernSexData(data) {
      data.forEach((item) => {
        item.gender = item.gender == true ? "男" : "女";
        item.workQualification = item.workQualification == true ? "是" : "否";
        item.birthday = item.birthday
          ? this.$moment(item.birthday).format("YYYY-MM-DD")
          : "";
      });
      return data;
    },

    //联系人弹窗action
    contactFinAdd(flag) {
      this.title = "添加联系人";
      this.contactFinType = 1;

      this.commonData = {};
      this.$set(this.commonData, "dte", new Date());
      this.contactVisible = true;
    },

    //高级管理人信息弹窗action
    legalCompAdd(flag) {
      if (flag == "legal") {
        if (this.isAgency) {
          this.title = "添加法定代表人/执行事务合伙人（委派代表）信息";
        } else {
          this.title = "添加高级管理人信息";
        }
        this.legalRiskType = 1;
      } else {
        // this.title = "添加实际控制人信息";
        // this.legalRiskType = 2;
      }
      this.commonData = {};
      this.$set(this.commonData, "dte", new Date());
      console.log(this.legalData);
      console.log(this.tableConf);
      console.log("~~this.tableConf~~");
      this.legalVisible = true;
    },
    //实际控制人弹窗action
    controllerAdd(flag) {
      if (flag == "controller") {
        this.title = "添加实际控制人信息";
        this.controllerFinType = 1;
      }
      this.commonData = {};
      this.$set(this.commonData, "dte", new Date());
      this.controllerVisible = true;
    },
    reload() {
      this.closeDialog();
      this.getAllPerson();
    },

    closeDialog() {
      this.getAllPerson();
      this.contactVisible = false;
      this.legalVisible = false;
      this.controllerVisible = false;
    },

    async editTable(data) {
      const $index = data.scope.$index;

      const id = data.scope.row.id;
      const flag = data.flag;
      if (flag == "1") {
        this.title = "编辑联系人";
        this.contactFinType = 1;
        // this.commonData = this.contactData[$index];
        this.getContactFinDetail(this.contactData, $index);
        this.$set(this.commonData, "dte", new Date());
        this.contactVisible = true;
      } else if (flag == "2") {
        if (this.isAgency) {
          this.title = "编辑法定代表人/执行事务合伙人（委派代表）信息";
        } else {
          this.title = "编辑高级管理人";
        }
        this.legalRiskType = 1;
        this.commonData = this.legalData[$index];
        this.commonData = this.reConvernData(this.commonData);
        this.commonData.qualification =
          this.commonData.qualification == "是" ? "1" : "0";
        // this.legalData[$index] = this.reConvernData(this.legalData[$index]);
        // this.getContactFinDetail(this.legalData, $index);
        this.$set(this.commonData, "dte", new Date());
        this.legalVisible = true;
      } else if (flag == "3") {
        this.title = "编辑实际控制人";
        this.controllerFinType = 2;
        // this.commonData = this.complianceData[$index];
        this.getContactFinDetail(this.controllerData, $index);
        this.$set(this.commonData, "dte", new Date());
        this.controllerVisible = true;
      }
    },

    // 获取联系人详情,全部数据已返回,不需要单独调接口
    getContactFinDetail(data, index) {
      this.commonData = data[index];
      console.log(data[index]);
    },

    handleSelectionChange(ids, flag) {
      this.selectIds[flag - 1] = ids;
      console.log(ids);
    },

    async del(flag) {
      const ids = this.selectIds[flag - 1];
      await delStep3(ids);
      this.$message({
        message: `删除成功!`,
        type: "success",
      });
      this.reload();
    },

    save() {
      return true;
    },
  },
};
</script>

<style scoped>
.title {
  margin: 20px;
}
</style>
